import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loginData: null,
  error: null,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    fetchLoginDataSuccess: (state, action) => {
      state.loginData = action.payload;
      state.error = null;
    },
    fetchLoginDataError: (state, action) => {
      state.loginData = null;
      state.error = action.payload;
    },
  },
});

export const { fetchLoginDataSuccess, fetchLoginDataError } = loginSlice.actions;
export default loginSlice.reducer;